import React, { useState, useEffect } from 'react';
import { signInWithGoogle } from '../services/authService';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [authStatus, setAuthStatus] = useState<string>('checking');
  const navigate = useNavigate();
  
  // Check authentication status on mount
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log('User is already signed in:', user.uid);
        setAuthStatus('authenticated');
        // Redirect to home page if already authenticated
        navigate('/');
      } else {
        console.log('No user signed in');
        setAuthStatus('unauthenticated');
      }
    });
    
    return () => unsubscribe();
  }, [navigate]);
  
  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log('Attempting to sign in with Google');
      const result = await signInWithGoogle();
      console.log('Sign in successful', result);
      
      // Redirect will happen automatically via the useEffect
    } catch (err: any) {
      console.error('Error during sign in:', err);
      // Provide more detailed error message
      if (err.code) {
        setError(`Sign-in error (${err.code}): ${err.message}`);
      } else {
        setError(err.message || 'An error occurred during sign in.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  if (authStatus === 'checking') {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-logo">
            <h1>NFI</h1>
          </div>
          <div className="login-spinner"></div>
          <p>Checking authentication status...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <h1>NFI</h1>
        </div>
        <h2>Lumper Receipt Creator</h2>
        <p className="login-subtitle">Streamline your delivery management</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <button 
          className="google-sign-in-btn" 
          onClick={handleGoogleSignIn} 
          disabled={loading}
        >
          <span className="icon">G</span>
          <span className="text">
            {loading ? 'Signing in...' : 'Sign in with Google'}
          </span>
        </button>
      </div>
    </div>
  );
};

export default Login; 